"use strict";

import NodeBase from "../util/NodeBase";
import { drawRoundRect } from "../util/shapes";

/**
 * A QueueUnit Node/Cluster shape.
 *
 * @augments QueueUnit
 */
class QueueUnit extends NodeBase {
  /**
   * @param {object} options
   * @param {object} body
   * @param {Label} labelModule
   * @param captionModule
   * @param iconsList
   */
  constructor(options, body, labelModule, captionModule, notationModule, iconsList) {
    super(options, body, labelModule, captionModule, notationModule);
    this._setMargins(labelModule);
    this.captionTextSize = { width: 0, height: 0 };
    this.iconsList = iconsList;

    this.width = 132; //dimensions.width + this.margin.right + this.margin.left;
    this.height = 72; //dimensions.height + this.margin.top + this.margin.bottom;
    this.radius = 6; //this.width / 2;
    this.headwidth = 24;
    this.headicon = { width: 20, height: 20 };
    this.icon = { width: 16, height: 16, margin: 2};
    this.caption_icon = { width: 20, height: 20, margin: 2 };
    this.toolbar = [
      { item: "remove", name: ["delete", "delete", "delete", "delete"], show: false, enable: false, type: options.toolbar.remove,  left: 0, top: 0, right: 0, bottom: 0 },
      { item: "clean", name: ["purge", "purge", "purge", "purge"], show: false, enable: false, type: options.toolbar.clean, left: 0, top: 0, right: 0, bottom: 0 },
      { item: "view", name: ["view", "view", "view", "view"], show: false, enable: false, type: options.toolbar.view, left: 0, top: 0, right: 0, bottom: 0 },
      { item: "setting", name: ["setting", "setting", "setting", "setting"], show: false, enable: false, type: options.toolbar.setting, left: 0, top: 0, right: 0, bottom: 0 },
    ]

    if (options.fixToolBar === false) {
      this.toolbar = [
        { item: "remove", name: ["delete", "delete", "delete", "delete"], show: (options.toolbar.remove === -1) ? false : true, type: options.toolbar.remove, left: 0, top: 0, right: 0, bottom: 0 },
        { item: "clean", name: ["purge", "purge", "purge", "purge"], show: (options.toolbar.clean === -1) ? false : true, type: options.toolbar.clean, left: 0, top: 0, right: 0, bottom: 0 },
        { item: "view", name: ["view", "view", "view", "view"], show: (options.toolbar.view === -1) ? false : true, type: options.toolbar.view, left: 0, top: 0, right: 0, bottom: 0 },
        { item: "setting", name: ["setting", "setting", "setting", "setting"], show: (options.toolbar.setting === -1) ? false : true, type: options.toolbar.setting, left: 0, top: 0, right: 0, bottom: 0 },
      ]
    }

    const offset = 2;
    if (options.toolbar) {
      for (let i = 0, idx = 0, len = this.toolbar.length; i < len; i++) {
        if (!this.toolbar[i].show) {
          continue;
        }
        idx++;
        // offset
        this.toolbar[i].left = this.width - (this.icon.width + this.icon.margin + this.icon.margin) * idx - offset;
        this.toolbar[i].right = this.toolbar[i].left + (this.icon.width + this.icon.margin + this.icon.margin);
        this.toolbar[i].top = this.height - (this.icon.width + this.icon.margin + this.icon.margin) - offset;
        this.toolbar[i].bottom = this.height - offset;
      }
    }
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {boolean} [selected]
   * @param {boolean} [hover]
   */
  resize(ctx, selected = this.selected, hover = this.hover) {
    if (this.needsRefresh(selected, hover)) {
      this.getDimensionsFromLabel(ctx, selected, hover);
      this.captionTextSize = this.captionModule.getTextSize(ctx, selected, hover);
    }
  }

  /**
   * @param {object}} [toolbar]
   */
  updateToolbar(toolbar) {
    for (let i = 0, len = this.toolbar.length; i < len; i++) {
      if (toolbar[this.toolbar[i].item] != undefined) {
        this.toolbar[i].type = toolbar[this.toolbar[i].item]
      }
      if (this.options.fixToolBar === false) {
        this.toolbar[i].show = (this.toolbar[i].type === -1 ? false : true);
      }
    }
    if (this.options.fixToolBar === false) {
      const offset = 2;
      for (let i = 0, idx = 0, len = this.toolbar.length; i < len; i++) {
        if (!this.toolbar[i].show) {
          this.toolbar[i].left = 0;
          this.toolbar[i].right = 0;
          this.toolbar[i].top = 0;
          this.toolbar[i].bottom = 0;
          continue;
        }
        idx++;
        this.toolbar[i].left = this.width - (this.icon.width + this.icon.margin + this.icon.margin) * idx - offset;
        this.toolbar[i].right = this.toolbar[i].left + (this.icon.width + this.icon.margin + this.icon.margin);
        this.toolbar[i].top = this.height - (this.icon.width + this.icon.margin + this.icon.margin) - offset;
        this.toolbar[i].bottom = this.height - offset;
      }
    }

    return true;
  }

  /**
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} x width
   * @param {number} y height
   * @param {boolean} selected
   * @param {boolean} hover
   * @param {ArrowOptions} values
   * @param pointer
   */
  draw(ctx, x, y, selected, hover, values, pointer) {
    this.resize(ctx, selected, hover);
    this.left = x - this.width / 2;
    this.top = y - this.height / 2;

    this.initContextForDraw(ctx, values);
    drawRoundRect(ctx, this.left, this.top, this.width, this.height, this.radius);
    this.performFill(ctx, values);

    this.drawHead(ctx, this.left, this.top, this.headwidth, this.height, this.radius);
    values.color = this.options.head.background || "#ffffff";
    this.performFill(ctx, values);

    //if (this.options.head && this.options.head.icon && this.iconsList[this.options.head.icon]) {
    //  ctx.drawImage(this.iconsList[this.options.head.icon].normal,
    //                this.left + (this.headwidth - this.headicon.width) / 2,
    //                this.top + (this.height - this.headicon.height) / 2,
    //                this.headicon.width,
    //                this.headicon.height);
    //} else {
      ctx.drawImage(this.iconsList.data.normal,
                    this.left + (this.headwidth - this.headicon.width) / 2,
                    this.top + (this.height - this.headicon.height) / 2,
                    this.headicon.width,
                    this.headicon.height);
    //}

    if (this.options.caption.enabled) {
      this.drawCaption(ctx, selected, hover);
    }

    if (this.options.notation.enabled) {
      this.drawNotation(ctx, selected, hover);
    }

    this.drawStatusBar(ctx, pointer, selected, hover);

    this.updateBoundingBox(x, y, ctx, selected, hover);
    this.drawLabel(ctx, selected, hover);
    if (values.useToolBar) {
      this.drawToolBar(ctx, pointer, selected, hover);
    }
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {boolean} selected
   * @param {boolean} hover
   */
  drawHead(ctx, x, y, w, h, r) {
    const r2d = Math.PI / 180;
    if (w - 2 * r < 0) {
      r = w / 2;
    } //ensure that the radius isn't too large for x
    if (h - 2 * r < 0) {
      r = h / 2;
    } //ensure that the radius isn't too large for y
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + w, y);
    ctx.lineTo(x + w, y + h);
    ctx.lineTo(x + r, y + h);
    ctx.arc(x + r, y + h - r, r, r2d * 90, r2d * 180, false);
    ctx.lineTo(x, y + r);
    ctx.arc(x + r, y + r, r, r2d * 180, r2d * 270, false);
    ctx.closePath();
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {boolean} selected
   * @param {boolean} hover
   */
  drawCaption(ctx, selected, hover) {
    if (this.options.caption.label) {
      const height = (this.options.caption.height > this.captionTextSize.height ? this.options.caption.height : this.captionTextSize.height);
      let ls = this.left + this.headwidth + 4;
      let ts = this.top + this.margin.top + 4;
      this.captionModule.draw(ctx, ls, ts, selected, hover, "top", "left");
    }
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {boolean} selected
   * @param {boolean} hover
   */
   drawNotation(ctx, selected, hover) {
    if (this.options.notation.label) {
      let ls = this.left + 4;
      let ts = this.top + this.height + 4;
      this.notationModule.draw(ctx, ls, ts, selected, hover, "top", "left");
    }
  }

  /**
   * @param {CanvasRenderingContext2D} ctx
   * @param {boolean} selected
   * @param {boolean} hover
   */
  drawLabel(ctx, selected, hover) {
    let ls = this.left + this.headwidth + 4;

    const capH = this.options.caption.height + this.options.caption.margin.top + this.options.caption.margin.bottom;
    let ts = (this.top + 32); // this.top + 48; // (this.top + this.height / 2 + 4); //this.top + capH + 8 - this.textSize.height / 2;

    this.labelModule.draw(ctx, ls, ts, selected, hover, "top", "left");
    // this.labelModule.draw(ctx, ls, ts, selected, hover, "middle", "left");
  }

  /**
   * @param {CanvasRenderingContext2D} ctx
   * @param pointer
   * @param {boolean} selected
   * @param {boolean} hover
   */
  drawStatusBar(ctx, pointer, selected, hover) {
    let status_state = "normal";
    let alert_state = "normal";
    if (hover) {
      if (pointer.y >= (this.top + 2) && pointer.y <= (this.top + 4 + this.caption_icon.height + 2) &&
        pointer.x >= (this.left + this.width - this.caption_icon.width - 4 - this.caption_icon.width - 4 - 2) &&
        pointer.x <= (this.left + this.width - this.caption_icon.width - 4 - 2)) {
        status_state = "hover";
      } else if (pointer.y >= (this.top + 2) && pointer.y <= (this.top + 4 + this.caption_icon.height + 2) &&
        pointer.x >= (this.left + this.width - this.caption_icon.width - 4 - 2) &&
        pointer.x <= (this.left + this.width - 2)) {
        alert_state = "hover";
      }
    }

    if (this.options.caption.status && this.options.caption.status != "none") {
      if (this.options.caption.status == 'submit') {
        ctx.drawImage(this.iconsList.vmark.normal, this.left + this.width - this.caption_icon.width - 4 - this.caption_icon.width - 4, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      } else if (this.options.caption.status == 'error') {
        ctx.drawImage(this.iconsList.xmark[status_state], this.left + this.width - this.caption_icon.width - 4 - this.caption_icon.width - 4, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      } else if (this.options.caption.status == 'unknown') {
        ctx.drawImage(this.iconsList.smark[status_state], this.left + this.width - this.caption_icon.width - 4 - this.caption_icon.width - 4, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      } else if (this.options.caption.status == 'pause') {
        ctx.drawImage(this.iconsList.pausemark[status_state], this.left + this.width - this.caption_icon.width - 4 - this.caption_icon.width - 4, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      } else if (this.options.caption.status == 'stop') {
        ctx.drawImage(this.iconsList.stopmark[status_state], this.left + this.width - this.caption_icon.width - 4 - this.caption_icon.width - 4, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      } else if (this.options.caption.status == 'disabled') {
        ctx.drawImage(this.iconsList.status_disabled[status_state], this.left + this.width - this.caption_icon.width - 4 - this.caption_icon.width - 4, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      } else if (this.options.caption.status == 'invalid') {
        ctx.drawImage(this.iconsList.status_invalid[status_state], this.left + this.width - this.caption_icon.width - 4 - this.caption_icon.width - 4, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      } else if (this.options.caption.status == 'stopped') {
        ctx.drawImage(this.iconsList.status_stopped[status_state], this.left + this.width - this.caption_icon.width - 4 - this.caption_icon.width - 4, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      } else if (this.options.caption.status == 'running') {
        ctx.drawImage(this.iconsList.status_running[status_state], this.left + this.width - this.caption_icon.width - 4 - this.caption_icon.width - 4, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      } else if (this.options.caption.status == 'validating') {
        ctx.drawImage(this.iconsList.status_validating[status_state], this.left + this.width - this.caption_icon.width - 2 - this.caption_icon.width - 2, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      }
    }

    if (this.options.caption.alert && this.options.caption.alert != "none") {
      if (this.options.caption.alert == 'on') {
        ctx.drawImage(this.iconsList.alert_on[alert_state], this.left + this.width - this.caption_icon.width - 2, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      } else if (this.options.caption.alert == 'off') {
        alert_state = "normal";
        ctx.drawImage(this.iconsList.alert_off[alert_state], this.left + this.width - this.caption_icon.width - 2, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      } else if (this.options.caption.alert == 'l1') {
        ctx.drawImage(this.iconsList.alert_l1[alert_state], this.left + this.width - this.caption_icon.width - 2, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      } else if (this.options.caption.alert == 'l2') {
        ctx.drawImage(this.iconsList.alert_l2[alert_state], this.left + this.width - this.caption_icon.width - 2, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      } else if (this.options.caption.alert == 'l3') {
        ctx.drawImage(this.iconsList.alert_l3[alert_state], this.left + this.width - this.caption_icon.width - 2, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      } else if (this.options.caption.alert == 'l4') {
        ctx.drawImage(this.iconsList.alert_l4[alert_state], this.left + this.width - this.caption_icon.width - 2, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      } else if (this.options.caption.alert == 's1') {
        ctx.drawImage(this.iconsList.alert_s1[alert_state], this.left + this.width - this.caption_icon.width - 2, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      } else if (this.options.caption.alert == 's2') {
        ctx.drawImage(this.iconsList.alert_s2[alert_state], this.left + this.width - this.caption_icon.width - 2, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      } else if (this.options.caption.alert == 's3') {
        ctx.drawImage(this.iconsList.alert_s3[alert_state], this.left + this.width - this.caption_icon.width - 2, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      } else if (this.options.caption.alert == 's4') {
        ctx.drawImage(this.iconsList.alert_s4[alert_state], this.left + this.width - this.caption_icon.width - 2, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      } else if (this.options.caption.alert == 'low') {
        ctx.drawImage(this.iconsList.alert_low[alert_state], this.left + this.width - this.caption_icon.width - 2, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      } else if (this.options.caption.alert == 'middle') {
        ctx.drawImage(this.iconsList.alert_middle[alert_state], this.left + this.width - this.caption_icon.width - 2, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      } else if (this.options.caption.alert == 'high') {
        ctx.drawImage(this.iconsList.alert_high[alert_state], this.left + this.width - this.caption_icon.width - 2, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      } else if (this.options.caption.alert == 'clock') {
        ctx.drawImage(this.iconsList.alert_clock[alert_state], this.left + this.width - this.caption_icon.width - 2, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      } else if (this.options.caption.alert == 'empty') {
        ctx.drawImage(this.iconsList.alert_empty[alert_state], this.left + this.width - this.caption_icon.width - 2, this.top + 4, this.caption_icon.width, this.caption_icon.height);
      }
    }
  }

  /**
   * @param {CanvasRenderingContext2D} ctx
   * @param pointer
   * @param {boolean} selected
   * @param {boolean} hover
   */
  drawToolBar(ctx, pointer, selected, hover) {
    for (let i = 0, state = "normal", len = this.toolbar.length; i < len; i++, state = "normal") {
      const img = this.toolbar[i].item + this.toolbar[i].type;
      if (!this.toolbar[i].show || !(this.iconsList[img])) {
        continue;
      }
      if (hover && this.toolbar[i].type > 1) {
        if (pointer.x >= this.left + this.toolbar[i].left && pointer.x <= this.left + this.toolbar[i].right &&
            pointer.y >= this.top + this.toolbar[i].top && pointer.y <= this.top + this.toolbar[i].bottom)
        {
          state = "hover";
        }
      }

      ctx.drawImage(this.iconsList[img][state],
                    this.left + this.toolbar[i].left + this.icon.margin,
                    this.top + this.toolbar[i].top + this.icon.margin,
                    this.icon.width,
                    this.icon.height);
    }
  }

  /**
   *
   * @param {number} x width
   * @param {number} y height
   * @param {CanvasRenderingContext2D} ctx
   * @param {boolean} selected
   * @param {boolean} hover
   */
  updateBoundingBox(x, y, ctx, selected, hover) {
    this._updateBoundingBox(x, y, ctx, selected, hover);

    const borderRadius = this.options.shapeProperties.borderRadius; // only effective for box
    this._addBoundingBoxMargin(borderRadius);
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} angle
   * @returns {number}
   */
  distanceToBorder(ctx, angle) {
    if (ctx) {
      this.resize(ctx);
    }
    const borderWidth = this.options.borderWidth;

    return (
      Math.min(
        Math.abs(this.width / 2 / Math.cos(angle)),
        Math.abs(this.height / 2 / Math.sin(angle))
      ) + borderWidth
    );
  }

  /**
   * @param {x: number, y: number} pointer
   */
  hitActionItem(pointer) {
    for (let i = 0, len = this.toolbar.length; i < len; i++) {
      if (!this.toolbar[i].show) {
        continue;
      }
      if (pointer.x >= this.left + this.toolbar[i].left && pointer.x <= this.left + this.toolbar[i].right &&
        pointer.y >= this.top + this.toolbar[i].top && pointer.y <= this.top + this.toolbar[i].bottom) {
        return this.toolbar[i].item;
      }
    }

    if (pointer.y >= (this.top + 2) && pointer.y <= (this.top + 4 + this.caption_icon.height + 2) &&
      pointer.x >= (this.left + this.width - this.caption_icon.width - 4 - this.caption_icon.width - 4 - 2) &&
      pointer.x <= (this.left + this.width - this.caption_icon.width - 4 - 2)) {
      return "state";
    } else if (pointer.y >= (this.top + 2) && pointer.y <= (this.top + 4 + this.caption_icon.height + 2) &&
      pointer.x >= (this.left + this.width - this.caption_icon.width - 4 - 2) &&
      pointer.x <= (this.left + this.width - 2)) {
      return "alert";
    }

    return "";
  }

  /**
   * @param {x: number, y: number} pointer
   */
  overActionItemName(pointer) {
    for (let i = 0, len = this.toolbar.length; i < len; i++) {
      if (!this.toolbar[i].show) {
        continue;
      }
      if (pointer.x >= this.left + this.toolbar[i].left && pointer.x <= this.left + this.toolbar[i].right &&
        pointer.y >= this.top + this.toolbar[i].top && pointer.y <= this.top + this.toolbar[i].bottom) {
        return this.toolbar[i].name[this.options.toolbar[this.toolbar[i].item]];
      }
    }

    if (pointer.y >= (this.top + 2) && pointer.y <= (this.top + 4 + this.caption_icon.height + 2) &&
      pointer.x >= (this.left + this.width - this.caption_icon.width - 4 - this.caption_icon.width - 4 - 2) &&
      pointer.x <= (this.left + this.width - this.caption_icon.width - 4 - 2)) {
      return this.options.caption.status;
    } else if (pointer.y >= (this.top + 2) && pointer.y <= (this.top + 4 + this.caption_icon.height + 2) &&
      pointer.x >= (this.left + this.width - this.caption_icon.width - 4 - 2) &&
      pointer.x <= (this.left + this.width - 2)) {
      return 'alert'; //this.options.caption.alert;
    }

    return "";
  }
}

export default QueueUnit;
